import axios from "@/plugins/axios.js";
import store from "../store";

export default {
  async getUserCompany() {
    const userCompany = await axios.getData(
      "/auth/get-user-company",
      localStorage.getItem("token")
    );
    return userCompany;
  },
  async getSiteInfo(emis, vue) {
    if (!emis) return null;

    store.commit("setLoader", true);

    try {
      const data = await axios.postData("/get-company-with-domain", { emis });

      vue.$emit("legal-services", data.legal_services);
      vue.$emit("get-company", data.company);

      store.commit("setCurrency", data.currency);
      store.commit("setUserCompany", data.company);
      store.commit("setCompanyLabels", data.labels);
      store.commit("setThemeColor", data.company.primary_bg_color);
      store.commit("setSecondaryColor", data.company.secondary_bg_color);
      store.commit("setAppName", data.company.name);

      // Save to localStorage
      localStorage.setItem("themeColor", data.company.primary_bg_color);
      localStorage.setItem("secondaryColor", data.company.secondary_bg_color);
      localStorage.setItem("appName", data.company.name);
      localStorage.setItem("userCompany", JSON.stringify(data.company));
      localStorage.setItem("companyLabels", JSON.stringify(data.labels));

      return data;
    } catch (error) {
      console.error("getSiteInfo error:", error);
      throw error;
    } finally {
      store.commit("setLoader", false);
    }
  },
};
